import i18n from "@/boot/i18n";

let notifyMixin = {
  methods: {
    $notifySuccess: function (notificationMessage = i18n.global.t('common.dataUpdatedSuccessfully'), notificationDuration = 3000) {
      this.$notify({
        group: 'foo',
        duration: notificationDuration,
        type: 'success-notification toast-notification',
        text: `<img src="${require('@/assets/app/icons/tick.svg')}" class="notify-icon"> ${notificationMessage}`,
        closeOnClick: true,
      })
    },
    $notifyError: function (notificationMessage = 'Something went wrong..Please try again later', notificationDuration = 3000) {
      this.$notify({
        group: 'foo',
        duration: notificationDuration,
        type: 'error-notification toast-notification',
        text: `<img src="${require('@/assets/app/icons/failuer-icon.svg')}" class="notify-icon"> ${notificationMessage}`,
        closeOnClick: true,
      })
    },
    $getFirstGqlErrorMessage: function (err, defaultMessage = 'Нешто не е во ред. Пробајте повторно подоцна.') {
      return err.graphQLErrors && err.graphQLErrors.length ?
        err.graphQLErrors[0].message : defaultMessage;
    },
    $getGqlError: function (err, defaultMessage = 'Нешто не е во ред. Пробајте повторно подоцна.') {
      console.log("err", err)
      return err.graphQLErrors ? err.graphQLErrors[0] : {message: defaultMessage};
    },
    $getFirstGqlErrorKey: function (err) {
      if (!err) {
        return ''
      }
      return err.graphQLErrors && err.graphQLErrors.length ?
        err.graphQLErrors[0].key : '';
    },
    $notifyJobMessage: function (type, messageCode, action) {
      const template = this.$tm('common.notificationMessages')?.[messageCode] ?? ''
      const actionWord = template.startsWith('{action}')
        ? action.charAt(0).toUpperCase() + action.slice(1)
        : action.toLowerCase()
      const message = this.$t(`common.notificationMessages.${messageCode}`, {action: actionWord})
      type === 'success' ? this.$notifySuccess(message) : this.$notifyError(message)
    },
    $handelRedirectForError: function (err) {

      let error = this.$getGqlError(err);
      if (error && error.statusCode === 404) {
        return this.$router.push({name: '404'})
      }
    }
  },
}


export default notifyMixin;
